import {Component, Input, OnInit} from '@angular/core';
import { Subject } from 'rxjs';
import { first } from 'rxjs';
import {getParams} from '../../../utils/utils.object';
import {SyndicatedOptions} from '../syndicated-options.interface';
import {brandHeaderDefaultOptions, cachedPath} from '../syndicated-options';
import {SYNDICATED_HEADER_ANIMATIONS} from './syndicated-header.animations';
import {WindowRef} from '../../../services/window-ref/window-ref.service';
import get from 'lodash-es/get';

@Component({
  selector: 'app-pep-syndicated-header',
  templateUrl: './syndicated-header.component.html',
  styleUrls: ['./syndicated-header.component.scss'],
  animations: [...SYNDICATED_HEADER_ANIMATIONS]
})
export class SyndicatedHeaderComponent implements OnInit {
  /**
   * Syndicated header base path
   * @var {string}
   */
  @Input() basePath: string;

  /**
   * Syndicated header version
   * @var {number}
   */
  @Input() version: number;

  /**
   * Current locale
   * @var {string}
   */
  @Input() locale: string;

  /**
   * Current language
   * @var {string}
   */
  @Input() language: string;

  /**
   * Site ID
   * @var {string}
   */
  @Input() siteId: string;

  /**
   * App environment
   * @var {string}
   */
  @Input() environment: string;

  /**
   * Hide navigation on header
   * @var {number}
   */
  @Input() hideNavigation: number;

  /**
   * Syndicated header URL
   * @var {string}
   */
  public syndicatedHeaderUrl: string;

  /**
   * Default options
   * @var {SyndicatedOptions}
   */
  public defaultOptions: SyndicatedOptions;

  /**
   * Whether to use cached header or not
   * @var {boolean}
   */
  public useCached: boolean; // @TODO validate if the user is not loggedIn to use cache.

  /**
   * Syndicated header status
   * @var {string}
   */
  public stateName: string;

  /**
   * Component constructor
   *
   * @param _windowRef
   */
  constructor(
    private _windowRef: WindowRef
  ) {
    this.useCached = false;
  }

  /**
   * On init method
   */
  public ngOnInit() {
    this.defaultOptions = {...brandHeaderDefaultOptions[this.siteId]};
    this.defaultOptions.version = this.version || this.defaultOptions.version;
    this.defaultOptions.locale = this.locale || this.defaultOptions.locale;
    this.defaultOptions.language = this.language || this.defaultOptions.language;
    this.defaultOptions.siteOverride = this.siteId;
    this.defaultOptions.hideNavigation = this.hideNavigation;
    this.syndicatedHeaderUrl = `${this.basePath}${this.useCached ? cachedPath : '/'}${getParams(this.defaultOptions)}`;
    this.stateName = 'loaded';

    // @TODO Remove this hack that prevents language modal to switch page's locale.
    this.setupSyndicatedToggles();
  }

  /**
   * Animates header after loading
   *
   * @param event
   *
   * @returns {void}
   */
  public headerStateDone(event: AnimationEvent): void {
    // We want to make sure that the animation is complete and the style has been set
    // by the animation module. Once that is done we can manually remove the style attr.
    setTimeout(() => {
      event['element'].removeAttribute('style');
    });
  }

  /**
   * Setup toggles needed for Syndicated Navbar.
   *
   * @TODO Remove this hack that prevents language modal to switch page's locale.
   *
   * @returns {void}
   */
  public setupSyndicatedToggles(): void {
    const windowRef = this._windowRef.nativeWindow,
      toggleReady: Subject<boolean> = new Subject(),
      releaseToggles = [
        'disableLocaleCookie',
        'disableLanguageSelectionCookie'
      ],
      toggleSetupInterval = setInterval(setToggles, 100);

    toggleReady.asObservable()
      .pipe(
        first()
      )
      .subscribe(() => {
        clearInterval(toggleSetupInterval);
      });

    function setToggles() {
      if (get(windowRef, 'PEP.Config.Toggles.Release', false)) {
        releaseToggles.forEach(function (toggle) {
          windowRef.PEP.Config.Toggles.Release[toggle] = true;
        });
        toggleReady.next(true);
      }
    }
  }
}

